import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label", "aria-haspopup", "onclick", "onkeydown", "disabled"]
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.icon)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(["icon-button", [
      _ctx.background ? 'background' : '',
      _ctx.transparentBackground ? 'transparent-background' : '',
      _ctx.dark ? 'dark' : '',
      _ctx.addPadding ? 'add-padding' : '',
      _ctx.xxsmall ? 'xxsmall' : '',
      _ctx.xsmall ? 'xsmall' : '',
      _ctx.small ? 'small' : '',
      _ctx.medium ? 'medium' : '',
      _ctx.big ? 'big' : '',
      _ctx.inheritSize ? 'inherit-size' : '',
    ]]),
        "aria-label": _ctx.ariaLabel,
        "aria-haspopup": _ctx.ariaPopup,
        onclick: _ctx.onclick,
        onkeydown: _ctx.handleKeyDown,
        disabled: _ctx.disabled
      }, [
        _createElementVNode("img", {
          src: _ctx.icon,
          alt: _ctx.alt,
          class: _normalizeClass([
        _ctx.rotated ? 'rotated' : '',
        _ctx.tiny && 'tiny',
        _ctx.xxxsmall ? 'xxxsmall' : '',
        _ctx.xxsmall ? 'xxsmall' : '',
        _ctx.xsmall ? 'xsmall' : '',
        _ctx.small ? 'small' : '',
        _ctx.big ? 'big' : '',
        _ctx.inheritSize ? 'inherit-size' : '',
        _ctx.rounded && 'rounded',
      ])
        }, null, 10, _hoisted_2)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}